<div *ngIf="component === 'page'">
    <cc-slot-races [lobbyType]="lobbyType" [category]="category"></cc-slot-races>
</div>
<div *ngIf="component === 'carousel'">
    <cc-slot-races-cards class="cc-slot-races-cards" [showPlaceholderCard]="true" [lobbyType]="lobbyType" [addUpcoming]="true" [category]="category">
    </cc-slot-races-cards>
</div>
